import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingRequest, GetPendingSCN, GetPendingSRA } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'
import UpdateQty from './UpdateQty';
import RejectAction from './RejectAction';
import { configuration } from '../Utils/config';
import Pagination from './Pagination';
import SearchComponent from './SearchComponent';

export default function RequestTechApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);

    const [SearchText, setSearchText] = useState("");

    //get current post

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }


    const AllSRA = async () => {
        let result = await GetPendingRequest()

        console.log("object pending request", result);

        if (result.status == true) {
            setData(result.queryresult.allrequest)
        }
    }


    const editQty = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
    }

    const openApprove = (id) => {
        onOpen()
        setId(id)
    }

    useEffect(() => {

        AllSRA()

    }, [isOpen, OpenModal]);


    return (
        <Box>
             <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"TicketNo, StaffEmail, ProductName"} />

            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

                <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Ticket No</Th>
                                <Th color="#fff">Staff Email</Th>
                                <Th color="#fff">Product name</Th>
                                <Th color="#fff">Qty Requested</Th>
                                <Th color="#fff">Request Date</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Location</Th>
                                <Th color="#fff">District</Th>
                                <Th color="#fff">Zone</Th>
                                <Th color="#fff">Feeder</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">Created Date</Th>
                                <Th color="#fff">First Approval </Th>
                                <Th color="#fff">Approve</Th>


                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SearchText === "" ? (
                                    currentData?.map((item, i) => (
                                    <TableRow
                                        key={i}
                                        sn={i + 1}
                                        type="RequestApprovalT"
                                        ticketNo={item.ticket}
                                        email={item.staffemail}
                                        productName={item.productname}
                                        qty={item.qtyrequested}
                                        store={item.store}
                                        location={item.location || "nil"}
                                        district={item.district || "nil"}
                                        zone={item.zone || "nil"}
                                        feeder={item.feeder || "nil"}
                                        status={item.status}
                                        createdAt={moment(item.createdAt).format("DD/MM/YYYY, h:mm:ss a")}
                                        approval={item.zm ? item.zm : item.dom ? item.dom : item.hodbd ? item.hodbd : item.hodpt ? item.hodpt : item.dm ? item.dm : item.hdo ? item.hdo : ""}
                                        dateReceived={moment(item.requestdate).format("DD/MM/YYYY")}
                                        Approve={() => openApprove(item._id)}
                                        onClick={() => editQty(item._id)}


                                    />
                                ))
                                ):(
                                    SearchText !== "" && currentData.filter(item => item.ticket?.toLowerCase().includes(SearchText) || item.staffemail?.toLowerCase().includes(SearchText) || item.productname?.toLowerCase().includes(SearchText)).length > 0 ? (
                                    currentData.filter(item => item.ticket?.toLowerCase().includes(SearchText) || item.staffemail?.toLowerCase().includes(SearchText) || item.productname?.toLowerCase().includes(SearchText)).
                                    map((item, i) => (
                                    <TableRow
                                        key={i}
                                        sn={i + 1}
                                        type="RequestApprovalT"
                                        ticketNo={item.ticket}
                                        email={item.staffemail}
                                        productName={item.productname}
                                        qty={item.qtyrequested}
                                        store={item.store}
                                        location={item.location || "nil"}
                                        district={item.district || "nil"}
                                        zone={item.zone || "nil"}
                                        feeder={item.feeder || "nil"}
                                        status={item.status}
                                        createdAt={moment(item.createdAt).format("DD/MM/YYYY, h:mm:ss a")}
                                        approval={item.zm ? item.zm : item.dom ? item.dom : item.hodbd ? item.hodbd : item.hodpt ? item.hodpt : item.dm ? item.dm : item.hdo ? item.hdo : ""}
                                        dateReceived={moment(item.requestdate).format("DD/MM/YYYY")}
                                        Approve={() => openApprove(item._id)}
                                        onClick={() => editQty(item._id)}


                                    />
                                ))
                                    ):(
                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                                    )

                                   
                                )

                               
                            }


                        </Tbody>

                    </Table>
                </TableContainer>
                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />

                {/* this is for the approval modal that receive the type of approval*/}

                <RejectAction SingleData={SingleData} isOpen={isOpen} onClose={onClose} id={Id} state="ApproveRequest" />
                <UpdateQty SingleData={SingleData} state="request" isOpen={OpenModal} onClose={() => setOpenModal(false)} id={Id} />


            </Box>
        </Box>
    )
}
